module.exports = __webpack_public_path__ + "BbPlusBanner.94d57f035f386008004e8a44828620df.png";